<template>
    <div class="profile-container--no-bg">
        <hr>
        <div class="flex justify-between px-5">
            <h6>Pretendes apagar a tua conta?</h6>
            <a class="cursor-pointer" @click="confirming = true">Apagar Conta</a>
        </div>
        <confirmation-modal
            v-if="confirming"
            title="Tens a certeza que queres apagar a tua conta?"
            button="Apagar Conta"
            @confirm="deleteProfile()"
            @cancel="confirming = false"
        >
        </confirmation-modal>
    </div>
</template>

<script>
import confirmationModal from './modals/confirmation-modal';

export default {
    components: {
        confirmationModal
    },
    data() {
        return {
            confirming: false
        }
    },
    methods: {
        deleteProfile() {
            console.log("delete profile placeholder")

            this.$axios.delete('/perfil')
            .then((response) => {
                console.log(response.status)
                switch(response.status){
                    case 204:
                        this.confirming = false
                        window.location = '/logout'
                        break;
                    case 403:
                        this.confirming = false
                        window.location = '/logout'
                        break;
                    case 500:
                        this.confirming = false
                        break;
                }
            })
            .catch((error) => {
                console.log(error.response.status)
                this.confirming = false
            })
        }
    },
}
</script>
